import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { MessageCircle, X } from "lucide-react";

// Attention-grabbing "incoming message" peek on first paint of landing.
// Shows a floating card that mimics a push notification from Today's Companion.
export const IncomingMessageTeaser = () => {
  const [daily, setDaily] = useState(null);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const seen = sessionStorage.getItem("mythos_teaser_seen");
    if (seen) return;
    api.get("/companions/daily").then((r) => {
      setDaily(r.data);
      // Delay so it feels like an incoming push
      setTimeout(() => setVisible(true), 2500);
    }).catch(() => {});
  }, []);

  const close = () => {
    setDismissed(true);
    setVisible(false);
    sessionStorage.setItem("mythos_teaser_seen", "1");
  };

  if (!visible || !daily || dismissed) return null;

  return (
    <div
      data-testid="incoming-teaser"
      className="hidden sm:block fixed bottom-5 right-5 z-40 w-[320px] max-w-[calc(100vw-2rem)] rounded-2xl border border-white/15 bg-black/70 backdrop-blur-xl shadow-[0_20px_60px_rgba(0,0,0,0.6)] overflow-hidden fade-in"
      style={{ animation: "fade-in 0.5s ease both" }}
    >
      <div className="flex items-start gap-3 p-3">
        <div className="h-11 w-11 rounded-full overflow-hidden ring-2 ring-rose-500/50 flex-shrink-0">
          <img src={daily.generated_portrait || daily.image_url} alt="" className="h-full w-full object-cover" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-0.5">
            <div className="font-serif text-sm font-semibold text-white truncate">{daily.name}</div>
            <span className="inline-flex items-center gap-1 rounded-full border border-rose-500/40 bg-rose-500/15 text-rose-200 px-1.5 py-0.5 text-[9px] font-mono uppercase tracking-widest">
              <span className="h-1 w-1 rounded-full bg-rose-400 animate-pulse" />now
            </span>
          </div>
          <div className="text-xs text-slate-300 font-serif italic line-clamp-2">"{daily.opening_line}"</div>
          <Link
            to={`/companions/${daily.companion_id}`}
            data-testid="incoming-teaser-reply"
            onClick={close}
            className="mt-2 inline-flex items-center gap-1 text-[11px] font-mono uppercase tracking-widest text-amber-300 hover:text-amber-200"
          >
            <MessageCircle className="h-3 w-3" /> Reply →
          </Link>
        </div>
        <button data-testid="incoming-teaser-close" onClick={close} className="rounded-full p-1 text-slate-500 hover:text-slate-200">
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
};
